import { Combobox } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { IncomingInvoiceReminderLinkSchema } from "@msuite/utils/schemas";
import { guardString } from "@msuite/utils/strings";
import { useFormContext } from "react-hook-form";
import { useIncomingInvoices } from "@/hooks/use-incoming-invoices";

/**
 * The invoice a reminder or a delivery note belongs to — any but a duplicate, whose original
 * takes it instead. Both link forms share the shape `{ incomingInvoiceId }`, emptied to take a
 * wrong link back.
 */
export function IncomingInvoiceLinkForm() {
	/** Context */
	const methods = useFormContext<IncomingInvoiceReminderLinkSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { incomingInvoices } = useIncomingInvoices();

	/** Computed */
	const options = incomingInvoices.filter((invoice) => invoice.state !== "duplicate");

	/** Render */
	return (
		<Combobox
			control={methods.control}
			name="incomingInvoiceId"
			options={options}
			displayValue={(invoice) =>
				`${guardString(invoice.number)} · ${guardString(invoice.contactName ?? invoice.issuerName)}`
			}
			keyExtractor={(invoice) => invoice.id}
			label={t("incoming_invoices.invoice")}
			placeholder={t("incoming_invoices.reminders.search_invoice")}
			isRequired={false}
			data-cy="incoming-invoice-link-picker"
		/>
	);
}
